var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChatTab = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49398 15.0246C4.77707 15.0246 4.97523 14.8912 5.30786 14.5825L7.3673 12.6807C6.97098 12.3649 6.64544 11.8667 6.64544 10.7228V6.07018C6.64544 3.91579 7.96178 2.6386 10.1345 2.6386H15.0885L15.0814 2.37193C14.9752 0.933333 14.0198 0 12.3992 0H2.68931C1.06865 0 0 0.961404 0 2.63158V9.52281C0 11.193 1.06865 12.2667 2.68931 12.2667H3.86412V14.3088C3.86412 14.7439 4.09766 15.0246 4.49398 15.0246ZM15.9306 16C16.334 16 16.5605 15.7123 16.5605 15.2842V13.2351H17.3107C18.9314 13.2351 20 12.1614 20 10.4982V6.23158C20 4.55439 18.9314 3.6 17.3107 3.6H10.2972C8.6058 3.6 7.615 4.55439 7.615 6.23158V10.4982C7.615 12.1614 8.6058 13.2351 10.2972 13.2351H12.5619L15.1168 15.5509C15.4494 15.8596 15.6476 16 15.9306 16Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChatTab);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-chat-tab.cac6d07371b5209f31d8af87b694d8b2.svg";